import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getEnvelopeEndpointWithUrlEncodedAuth } from './api.js';
import { getTraceContextFromScope, getCurrentScope, getIsolationScope } from './currentScopes.js';
import { DEBUG_BUILD } from './debug-build.js';
import { createEventEnvelope, createSessionEnvelope } from './envelope.js';
import { setupIntegration, afterSetupIntegrations, setupIntegrations } from './integration.js';
import { updateSession } from './session.js';
import { getDynamicSamplingContextFromScope } from './tracing/dynamicSamplingContext.js';
import { createClientReportEnvelope } from './utils-hoist/clientreport.js';
import { makeDsn, dsnToString } from './utils-hoist/dsn.js';
import { addItemToEnvelope, createAttachmentEnvelopeItem } from './utils-hoist/envelope.js';
import { SentryError } from './utils-hoist/error.js';
import { isPrimitive, isThenable, isPlainObject, isParameterizedString } from './utils-hoist/is.js';
import { logger, consoleSandbox } from './utils-hoist/logger.js';
import { uuid4, checkOrSetAlreadyCaught } from './utils-hoist/misc.js';
import { resolvedSyncPromise, SyncPromise, rejectedSyncPromise } from './utils-hoist/syncpromise.js';
import { parseSampleRate } from './utils/parseSampleRate.js';
import { prepareEvent } from './utils/prepareEvent.js';
import { showSpanDropWarning } from './utils/spanUtils.js';
var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /*#__PURE__*/function () {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  function BaseClient(options) {
    _classCallCheck(this, BaseClient);
    this._options = options;
    this._integrations = {};
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];
    if (options.dsn) {
      this._dsn = makeDsn(options.dsn);
    } else {
      DEBUG_BUILD && logger.warn('No DSN provided, client will not send events.');
    }
    if (this._dsn) {
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
      this._transport = options.transport(_objectSpread(_objectSpread({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this)
      }, options.transportOptions), {}, {
        url: url
      }));
    }

    // TODO(v9): Remove this deprecation warning
    var tracingOptions = ['enableTracing', 'tracesSampleRate', 'tracesSampler'];
    var undefinedOption = tracingOptions.find(function (option) {
      return option in options && options[option] == undefined;
    });
    if (undefinedOption) {
      consoleSandbox(function () {
        // eslint-disable-next-line no-console
        console.warn("[Sentry] Deprecation warning: `".concat(undefinedOption, "` is set to undefined, which leads to tracing being enabled. In v9, a value of `undefined` will result in tracing being disabled."));
      });
    }
  }

  /**
   * @inheritDoc
   */
  _createClass(BaseClient, [{
    key: "captureException",
    value: function captureException(exception, hint, scope) {
      var _this = this;
      var eventId = uuid4();

      // ensure we haven't captured this very object before
      if (checkOrSetAlreadyCaught(exception)) {
        DEBUG_BUILD && logger.log(ALREADY_SEEN_ERROR);
        return eventId;
      }
      var hintWithEventId = _objectSpread({
        event_id: eventId
      }, hint);
      this._process(this.eventFromException(exception, hintWithEventId).then(function (event) {
        return _this._captureEvent(event, hintWithEventId, scope);
      }));
      return hintWithEventId.event_id;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "captureMessage",
    value: function captureMessage(message, level, hint, currentScope) {
      var _this2 = this;
      var hintWithEventId = _objectSpread({
        event_id: uuid4()
      }, hint);
      var eventMessage = isParameterizedString(message) ? message : String(message);
      var promisedEvent = isPrimitive(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
      this._process(promisedEvent.then(function (event) {
        return _this2._captureEvent(event, hintWithEventId, currentScope);
      }));
      return hintWithEventId.event_id;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "captureEvent",
    value: function captureEvent(event, hint, currentScope) {
      var eventId = uuid4();

      // ensure we haven't captured this very object before
      if (hint && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
        DEBUG_BUILD && logger.log(ALREADY_SEEN_ERROR);
        return eventId;
      }
      var hintWithEventId = _objectSpread({
        event_id: eventId
      }, hint);
      var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
      var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
      this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
      return hintWithEventId.event_id;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "captureSession",
    value: function captureSession(session) {
      if (!(typeof session.release === 'string')) {
        DEBUG_BUILD && logger.warn('Discarded session because of missing or non-string release');
      } else {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        updateSession(session, {
          init: false
        });
      }
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "getDsn",
    value: function getDsn() {
      return this._dsn;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }

    /**
     * @see SdkMetadata
     *
     * @return The metadata of the SDK
     */
  }, {
    key: "getSdkMetadata",
    value: function getSdkMetadata() {
      return this._options._metadata;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "getTransport",
    value: function getTransport() {
      return this._transport;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "flush",
    value: function flush(timeout) {
      var transport = this._transport;
      if (transport) {
        this.emit('flush');
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
          return transport.flush(timeout).then(function (transportFlushed) {
            return clientFinished && transportFlushed;
          });
        });
      } else {
        return resolvedSyncPromise(true);
      }
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "close",
    value: function close(timeout) {
      var _this3 = this;
      return this.flush(timeout).then(function (result) {
        _this3.getOptions().enabled = false;
        _this3.emit('close');
        return result;
      });
    }

    /** Get all installed event processors. */
  }, {
    key: "getEventProcessors",
    value: function getEventProcessors() {
      return this._eventProcessors;
    }

    /** @inheritDoc */
  }, {
    key: "addEventProcessor",
    value: function addEventProcessor(eventProcessor) {
      this._eventProcessors.push(eventProcessor);
    }

    /** @inheritdoc */
  }, {
    key: "init",
    value: function init() {
      if (this._isEnabled() ||
      // Force integrations to be setup even if no DSN was set when we have
      // Spotlight enabled. This is particularly important for browser as we
      // don't support the `spotlight` option there and rely on the users
      // adding the `spotlightBrowserIntegration()` to their integrations which
      // wouldn't get initialized with the check below when there's no DSN set.
      this._options.integrations.some(function (_ref) {
        var name = _ref.name;
        return name.startsWith('Spotlight');
      })) {
        this._setupIntegrations();
      }
    }

    /**
     * Gets an installed integration by its name.
     *
     * @returns The installed integration or `undefined` if no integration with that `name` was installed.
     */
  }, {
    key: "getIntegrationByName",
    value: function getIntegrationByName(integrationName) {
      return this._integrations[integrationName];
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "addIntegration",
    value: function addIntegration(integration) {
      var isAlreadyInstalled = this._integrations[integration.name];

      // This hook takes care of only installing if not already installed
      setupIntegration(this, integration, this._integrations);
      // Here we need to check manually to make sure to not run this multiple times
      if (!isAlreadyInstalled) {
        afterSetupIntegrations(this, [integration]);
      }
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "sendEvent",
    value: function sendEvent(event) {
      var _this4 = this;
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.emit('beforeSendEvent', event, hint);
      var env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
      var _iterator = _createForOfIteratorHelper(hint.attachments || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attachment = _step.value;
          env = addItemToEnvelope(env, createAttachmentEnvelopeItem(attachment));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var promise = this.sendEnvelope(env);
      if (promise) {
        promise.then(function (sendResponse) {
          return _this4.emit('afterSendEvent', event, sendResponse);
        }, null);
      }
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "sendSession",
    value: function sendSession(session) {
      var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);

      // sendEnvelope should not throw
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.sendEnvelope(env);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "recordDroppedEvent",
    value: function recordDroppedEvent(reason, category, eventOrCount) {
      if (this._options.sendClientReports) {
        // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
        // If event is passed as third argument, we assume this is a count of 1
        var count = typeof eventOrCount === 'number' ? eventOrCount : 1;

        // We want to track each category (error, transaction, session, replay_event) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        // With typescript 4.1 we could even use template literal types
        var key = "".concat(reason, ":").concat(category);
        DEBUG_BUILD && logger.log("Recording outcome: \"".concat(key, "\"").concat(count > 1 ? " (".concat(count, " times)") : ''));
        this._outcomes[key] = (this._outcomes[key] || 0) + count;
      }
    }

    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */

    /** @inheritdoc */

    /** @inheritdoc */
  }, {
    key: "on",
    value: function on(hook, callback) {
      var hooks = this._hooks[hook] = this._hooks[hook] || [];

      // @ts-expect-error We assume the types are correct
      hooks.push(callback);

      // This function returns a callback execution handler that, when invoked,
      // deregisters a callback. This is crucial for managing instances where callbacks
      // need to be unregistered to prevent self-referencing in callback closures,
      // ensuring proper garbage collection.
      return function () {
        // @ts-expect-error We assume the types are correct
        var cbIndex = hooks.indexOf(callback);
        if (cbIndex > -1) {
          hooks.splice(cbIndex, 1);
        }
      };
    }

    /** @inheritdoc */

    /** @inheritdoc */
  }, {
    key: "emit",
    value: function emit(hook) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      var callbacks = this._hooks[hook];
      if (callbacks) {
        callbacks.forEach(function (callback) {
          return callback.apply(void 0, rest);
        });
      }
    }

    /**
     * @inheritdoc
     */
  }, {
    key: "sendEnvelope",
    value: function sendEnvelope(envelope) {
      this.emit('beforeEnvelope', envelope);
      if (this._isEnabled() && this._transport) {
        return this._transport.send(envelope).then(null, function (reason) {
          DEBUG_BUILD && logger.error('Error while sending envelope:', reason);
          return reason;
        });
      }
      DEBUG_BUILD && logger.error('Transport disabled');
      return resolvedSyncPromise({});
    }

    /* eslint-enable @typescript-eslint/unified-signatures */

    /** Setup integrations for this client. */
  }, {
    key: "_setupIntegrations",
    value: function _setupIntegrations() {
      var integrations = this._options.integrations;
      this._integrations = setupIntegrations(this, integrations);
      afterSetupIntegrations(this, integrations);
    }

    /** Updates existing session based on the provided event */
  }, {
    key: "_updateSessionFromEvent",
    value: function _updateSessionFromEvent(session, event) {
      var crashed = false;
      var errored = false;
      var exceptions = event.exception && event.exception.values;
      if (exceptions) {
        errored = true;
        var _iterator2 = _createForOfIteratorHelper(exceptions),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ex = _step2.value;
            var mechanism = ex.mechanism;
            if (mechanism && mechanism.handled === false) {
              crashed = true;
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      // A session is updated and that session update is sent in only one of the two following scenarios:
      // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
      // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
      var sessionNonTerminal = session.status === 'ok';
      var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
      if (shouldUpdateAndSend) {
        updateSession(session, _objectSpread(_objectSpread({}, crashed && {
          status: 'crashed'
        }), {}, {
          errors: session.errors || Number(errored || crashed)
        }));
        this.captureSession(session);
      }
    }

    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
  }, {
    key: "_isClientDoneProcessing",
    value: function _isClientDoneProcessing(timeout) {
      var _this5 = this;
      return new SyncPromise(function (resolve) {
        var ticked = 0;
        var tick = 1;
        var interval = setInterval(function () {
          if (_this5._numProcessing == 0) {
            clearInterval(interval);
            resolve(true);
          } else {
            ticked += tick;
            if (timeout && ticked >= timeout) {
              clearInterval(interval);
              resolve(false);
            }
          }
        }, tick);
      });
    }

    /** Determines whether this SDK is enabled and a transport is present. */
  }, {
    key: "_isEnabled",
    value: function _isEnabled() {
      return this.getOptions().enabled !== false && this._transport !== undefined;
    }

    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param currentScope A scope containing event metadata.
     * @returns A new event with more information.
     */
  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint) {
      var _this6 = this;
      var currentScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getCurrentScope();
      var isolationScope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getIsolationScope();
      var options = this.getOptions();
      var integrations = Object.keys(this._integrations);
      if (!hint.integrations && integrations.length > 0) {
        hint.integrations = integrations;
      }
      this.emit('preprocessEvent', event, hint);
      if (!event.type) {
        isolationScope.setLastEventId(event.event_id || hint.event_id);
      }
      return prepareEvent(options, event, hint, currentScope, this, isolationScope).then(function (evt) {
        if (evt === null) {
          return evt;
        }
        evt.contexts = _objectSpread({
          trace: getTraceContextFromScope(currentScope)
        }, evt.contexts);
        var dynamicSamplingContext = getDynamicSamplingContextFromScope(_this6, currentScope);
        evt.sdkProcessingMetadata = _objectSpread({
          dynamicSamplingContext: dynamicSamplingContext
        }, evt.sdkProcessingMetadata);
        return evt;
      });
    }

    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
  }, {
    key: "_captureEvent",
    value: function _captureEvent(event) {
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var scope = arguments.length > 2 ? arguments[2] : undefined;
      return this._processEvent(event, hint, scope).then(function (finalEvent) {
        return finalEvent.event_id;
      }, function (reason) {
        if (DEBUG_BUILD) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          var sentryError = reason;
          if (sentryError.logLevel === 'log') {
            logger.log(sentryError.message);
          } else {
            logger.warn(sentryError);
          }
        }
        return undefined;
      });
    }

    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param currentScope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
  }, {
    key: "_processEvent",
    value: function _processEvent(event, hint, currentScope) {
      var _this7 = this;
      var options = this.getOptions();
      var sampleRate = options.sampleRate;
      var isTransaction = isTransactionEvent(event);
      var isError = isErrorEvent(event);
      var eventType = event.type || 'error';
      var beforeSendLabel = "before send for type `".concat(eventType, "`");

      // 1.0 === 100% events are sent
      // 0.0 === 0% events are sent
      // Sampling for transaction happens somewhere else
      var parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : parseSampleRate(sampleRate);
      if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
        this.recordDroppedEvent('sample_rate', 'error', event);
        return rejectedSyncPromise(new SentryError("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")"), 'log'));
      }
      var dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
      var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
      var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
      return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then(function (prepared) {
        if (prepared === null) {
          _this7.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }
        var isInternalException = hint.data && hint.data.__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }
        var result = processBeforeSend(_this7, options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      }).then(function (processedEvent) {
        if (processedEvent === null) {
          _this7.recordDroppedEvent('before_send', dataCategory, event);
          if (isTransaction) {
            var spans = event.spans || [];
            // the transaction itself counts as one span, plus all the child spans that are added
            var spanCount = 1 + spans.length;
            _this7.recordDroppedEvent('before_send', 'span', spanCount);
          }
          throw new SentryError("".concat(beforeSendLabel, " returned `null`, will not send event."), 'log');
        }
        var session = currentScope && currentScope.getSession();
        if (!isTransaction && session) {
          _this7._updateSessionFromEvent(session, processedEvent);
        }
        if (isTransaction) {
          var spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
          var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
          var droppedSpanCount = spanCountBefore - spanCountAfter;
          if (droppedSpanCount > 0) {
            _this7.recordDroppedEvent('before_send', 'span', droppedSpanCount);
          }
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        var transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          var source = 'custom';
          processedEvent.transaction_info = _objectSpread(_objectSpread({}, transactionInfo), {}, {
            source: source
          });
        }
        _this7.sendEvent(processedEvent, hint);
        return processedEvent;
      }).then(null, function (reason) {
        if (reason instanceof SentryError) {
          throw reason;
        }
        _this7.captureException(reason, {
          data: {
            __sentry__: true
          },
          originalException: reason
        });
        throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
      });
    }

    /**
     * Occupies the client with processing and event
     */
  }, {
    key: "_process",
    value: function _process(promise) {
      var _this8 = this;
      this._numProcessing++;
      void promise.then(function (value) {
        _this8._numProcessing--;
        return value;
      }, function (reason) {
        _this8._numProcessing--;
        return reason;
      });
    }

    /**
     * Clears outcomes on this client and returns them.
     */
  }, {
    key: "_clearOutcomes",
    value: function _clearOutcomes() {
      var outcomes = this._outcomes;
      this._outcomes = {};
      return Object.entries(outcomes).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          quantity = _ref3[1];
        var _key$split = key.split(':'),
          _key$split2 = _slicedToArray(_key$split, 2),
          reason = _key$split2[0],
          category = _key$split2[1];
        return {
          reason: reason,
          category: category,
          quantity: quantity
        };
      });
    }

    /**
     * Sends client reports as an envelope.
     */
  }, {
    key: "_flushOutcomes",
    value: function _flushOutcomes() {
      DEBUG_BUILD && logger.log('Flushing outcomes...');
      var outcomes = this._clearOutcomes();
      if (outcomes.length === 0) {
        DEBUG_BUILD && logger.log('No outcomes to send');
        return;
      }

      // This is really the only place where we want to check for a DSN and only send outcomes then
      if (!this._dsn) {
        DEBUG_BUILD && logger.log('No dsn provided, will not send outcomes');
        return;
      }
      DEBUG_BUILD && logger.log('Sending outcomes:', outcomes);
      var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsnToString(this._dsn));

      // sendEnvelope should not throw
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.sendEnvelope(envelope);
    }

    /**
     * @inheritDoc
     */
  }]);
  return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
  var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
  if (isThenable(beforeSendResult)) {
    return beforeSendResult.then(function (event) {
      if (!isPlainObject(event) && event !== null) {
        throw new SentryError(invalidValueError);
      }
      return event;
    }, function (e) {
      throw new SentryError("".concat(beforeSendLabel, " rejected with ").concat(e));
    });
  } else if (!isPlainObject(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(client, options, event, hint) {
  var beforeSend = options.beforeSend,
    beforeSendTransaction = options.beforeSendTransaction,
    beforeSendSpan = options.beforeSendSpan;
  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }
  if (isTransactionEvent(event)) {
    if (event.spans && beforeSendSpan) {
      var processedSpans = [];
      var _iterator3 = _createForOfIteratorHelper(event.spans),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var span = _step3.value;
          var processedSpan = beforeSendSpan(span);
          if (processedSpan) {
            processedSpans.push(processedSpan);
          } else {
            showSpanDropWarning();
            client.recordDroppedEvent('before_send', 'span');
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      event.spans = processedSpans;
    }
    if (beforeSendTransaction) {
      if (event.spans) {
        // We store the # of spans before processing in SDK metadata,
        // so we can compare it afterwards to determine how many spans were dropped
        var spanCountBefore = event.spans.length;
        event.sdkProcessingMetadata = _objectSpread(_objectSpread({}, event.sdkProcessingMetadata), {}, {
          spanCountBeforeProcessing: spanCountBefore
        });
      }
      return beforeSendTransaction(event, hint);
    }
  }
  return event;
}
function isErrorEvent(event) {
  return event.type === undefined;
}
function isTransactionEvent(event) {
  return event.type === 'transaction';
}
export { BaseClient };